import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tun-clock-icon',
  templateUrl: './clock-icon.component.html',
  styleUrls: ['./clock-icon.component.scss']
})
export class ClockIconComponent implements OnInit {

  constructor() { }

  @Input() color: string;

  ngOnInit() {
  }

}
